import { Link, useLocation } from "react-router-dom";
import { TrendingUp } from "lucide-react";

export default function Header() {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 bg-white border-b border-sif card-shadow"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-sif-primary flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <div className="text-lg font-semibold text-sif-primary leading-tight">SIFAnalytics</div>
            <div className="text-[10px] text-sif-muted uppercase tracking-widest">India SIF Intelligence</div>
          </div>
        </Link>

        <nav className="flex items-center gap-6 text-sm font-medium">
          <Link
            data-testid="nav-home"
            to="/"
            className={`transition-colors ${pathname === "/" ? "text-sif-primary" : "text-sif-muted hover:text-sif-primary"}`}
          >
            Funds
          </Link>
          <a href="#" className="text-sif-muted hover:text-sif-primary transition-colors">Analytics</a>
          <Link
            data-testid="nav-compare"
            to="/compare"
            className={`transition-colors ${pathname.startsWith("/compare") ? "text-sif-primary" : "text-sif-muted hover:text-sif-primary"}`}
          >
            Compare
          </Link>
          <Link
            data-testid="nav-amcs"
            to="/amcs"
            className={`transition-colors ${pathname.startsWith("/amcs") ? "text-sif-primary" : "text-sif-muted hover:text-sif-primary"}`}
          >
            AMCs
          </Link>
        </nav>

        <button
          data-testid="header-cta"
          className="hidden md:inline-flex items-center px-4 py-2 rounded-lg bg-sif-primary text-white text-sm font-semibold hover:opacity-90 transition"
        >
          Start Investing
        </button>
      </div>
    </header>
  );
}
